export * from './NftDetailsBid';
